import React, { useState, useEffect } from "react";
import {
  Header,
  Container,
  Table,
  Button,
  Icon,
  Form,
  Modal,
} from "semantic-ui-react";
import _ from "lodash";
import { configOptions } from "env.config";
import { PendingRow } from "components/Admin/PendingRow";
import { updateAppProfile } from "services/developer";
const ProfileActionButton = ({ appDetail, setOpenModal }) => {
  if (!appDetail || !appDetail.AppId) {
    return null;
  }

  return (
    <div className="action-group">
      <Button icon onClick={() => setOpenModal(true)}>
        <Icon name="plus" />
      </Button>
    </div>
  );
};

const Profile = ({ appDetail, handleMessage, profileList }) => {
  const [loaded, setLoaded] = useState(false);
  const [assignedProfileList, setAssignedProfileList] = useState([]);
  const [availProfileList, setAvailProfileList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({
    scope: "",
    scopeValid: true,
    stage: "",
    stageValid: true,
    profileName: "",
    profileNameValid: true,
  });

  useEffect(() => {
    (async () => {
      if (appDetail) {
        if (appDetail && appDetail.Profile && appDetail.Profile.length) {
          const assignedIdList = appDetail.Profile.map((p) => p.ProfileId);
          const assignedProfileList = profileList.filter((p) =>
            assignedIdList.includes(p.ProfileId)
          );
          setAssignedProfileList(assignedProfileList);
        } else {
          setAssignedProfileList([]);
        }
        setLoaded(true);
      }
    })();
  }, [appDetail, profileList]);

  const onDeleteProfile = async (profileId) => {
    setLoaded(false);
    const profile = assignedProfileList.filter(
      (p) => p.ProfileId !== profileId
    );
    await handleSaveProfile(profile, "deleteAppProfile");
  };

  const resetFormData = (overrideVal) => {
    const initFormData = {
      scope: "",
      scopeValid: true,
      stage: "",
      stageValid: true,
      profileName: "",
      profileNameValid: true,
    };
    const formData = { ...initFormData, ...overrideVal };
    setFormData(formData);
  };

  const onChangeScope = (_e, { value }) => {
    resetFormData({ scope: value });
  };

  const onChangeStage = (_e, { value }) => {
    resetFormData({ scope: formData.scope, stage: value });
    const availProfileList = profileList
      .filter(
        (p) =>
          p.Scope === formData.scope &&
          p.Stage === value &&
          (!p.MES || (p.MES && p.MES !== "MES16"))
      )
      .map((p) => {
        return {
          key: p.ProfileId,
          text: p.ProfileName,
          value: p.ProfileId,
        };
      });
    setAvailProfileList(availProfileList);
  };
  const onChangeProfileName = (_e, { value }) => {
    setFormData({ ...formData, profileName: value, profileNameValid: true });
  };

  const onCancelProfile = () => {
    resetFormData({});
    setOpenModal(false);
  };

  const handleSaveProfile = async (profile, operation) => {
    const params = { userName: appDetail.UserName, profile };
    const res = await updateAppProfile(params);
    if (res.success) {
      setAssignedProfileList(profile);
    }
    setLoaded(true);
    handleMessage({
      success: res.success,
      operation,
      content: res.message,
    });
  };

  const validateFormData = () => {
    if (!formData.scope || !formData.stage || !formData.profileName) {
      setFormData({
        ...formData,
        scopeValid: Boolean(formData.scope),
        stageValid: Boolean(formData.stage),
        profileNameValid: Boolean(formData.profileName),
      });
      return true;
    }
  };

  const onAddProfile = async () => {
    if (validateFormData()) return;
    onCancelProfile();
    setLoaded(false);
    const currentProfile = profileList.filter(
      (p) => p.ProfileId === formData.profileName
    );
    const profile = assignedProfileList.concat(currentProfile).map((item) => {
      return {
        ProfileId: item.ProfileId,
        ProfileName: item.ProfileName,
        Scope: item.Scope,
        Stage: item.Stage,
      };
    });
    await handleSaveProfile(profile, "addAppProfile");
  };

  return (
    <Container className="tab-item-container">
      <Header as="h4">Profiles</Header>
      <ProfileActionButton appDetail={appDetail} setOpenModal={setOpenModal} />
      <DisplayProfileList
        loaded={loaded}
        assignedProfileList={assignedProfileList}
        onDeleteProfile={onDeleteProfile}
      />
      <ProfileModal
        openModal={openModal}
        formData={formData}
        availProfileList={availProfileList}
        onChangeScope={onChangeScope}
        onChangeStage={onChangeStage}
        onChangeProfileName={onChangeProfileName}
        onCancelProfile={onCancelProfile}
        onAddProfile={onAddProfile}
      />
    </Container>
  );
};

const ProfileModal = ({
  openModal,
  formData,
  availProfileList,
  onChangeScope,
  onChangeStage,
  onChangeProfileName,
  onCancelProfile,
  onAddProfile,
}) => {
  return (
    <Modal closeIcon size="small" open={openModal} onClose={onCancelProfile}>
      <Modal.Header>Assign Profile</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field required>
            <label>Scope</label>
            <Form.Select
              fluid
              options={configOptions.scope}
              placeholder="Scope"
              error={!formData.scopeValid}
              value={formData.scope}
              onChange={onChangeScope}
            />
          </Form.Field>
          <Form.Field required>
            <label>Stage</label>
            <Form.Select
              fluid
              options={configOptions.stage}
              placeholder="Stage"
              error={!formData.stageValid}
              value={formData.stage}
              onChange={onChangeStage}
            />
          </Form.Field>
          <Form.Field required>
            <label>Profile Name</label>
            <Form.Select
              search
              fluid
              options={availProfileList}
              placeholder="Profile Name"
              error={!formData.profileNameValid}
              value={formData.profileName}
              onChange={onChangeProfileName}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancelProfile}>Cancel</Button>
        <Button type="submit" positive onClick={onAddProfile}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const DisplayProfileList = ({
  assignedProfileList,
  onDeleteProfile,
  loaded,
}) => {
  const tableBody = () => {
    if (!loaded) {
      return _.range(3).map((index) => (
        <PendingRow columnCount={3} key={index} />
      ));
    }

    return assignedProfileList.map((item) => {
      return (
        <Table.Row key={item.ProfileId}>
          <Table.Cell>{item.Scope}</Table.Cell>
          <Table.Cell>{item.Stage}</Table.Cell>
          <Table.Cell>
            <span style={{ marginRight: "5px" }}>{item.ProfileName}</span>
            <Button
              icon
              className="delete-icon"
              size="mini"
              compact
              onClick={() => onDeleteProfile(item.ProfileId)}
            >
              <Icon name="delete" />
            </Button>
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  return (
    <Table className="profile-table">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell style={{ width: "33.3%" }}>Scope</Table.HeaderCell>
          <Table.HeaderCell style={{ width: "33.3%" }}>Stage</Table.HeaderCell>
          <Table.HeaderCell>Profile Name</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{tableBody()}</Table.Body>
    </Table>
  );
};

export { Profile };
